/**
 * @generated SignedSource<<fabf85ae6b7e0ae74ea831e062fe6363>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NavigationTeamButton_project$data = {
  readonly id: string;
  readonly " $fragmentType": "NavigationTeamButton_project";
};
export type NavigationTeamButton_project$key = {
  readonly " $data"?: NavigationTeamButton_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavigationTeamButton_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NavigationTeamButton_project",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "d8eed5fcee084fa182d484b7d4a1a82d";

export default node;
